/* vp-cro-20260822 — VitaPop CRO enhancers (owner-approved 2026-08-22).
   Additive only: every feature no-ops if its target is missing.
   Injected text nodes carry data-vp-annotated="1" so the theme's annotateSub
   rewriter (layout/theme.liquid) leaves them alone.

   2026-09-14 — two changes, both PDP-only:
     * block 3 no longer ASSUMES a 20% subscription discount. It hardcoded
       full * 0.8, which printed £35.99 next to a plan that actually costs
       £30.14 once the offer moved to 33% off — understating our own discount
       by £5.85 on the option we want people to take. It now reads the real
       price the Subscriptions app rendered, so it can never drift again.
     * block 7 preselects the subscription option (see its own note).
*/
(function () {
  "use strict";
  var MOBILE = window.matchMedia("(max-width: 749px)").matches;

  function retry(fn, tries, gap) {
    var n = 0;
    (function tick() {
      try { if (fn()) return; } catch (e) { /* no-op */ }
      if (++n < tries) setTimeout(tick, gap);
    })();
  }

  /* price out of an aria-label / attribute like "Product price £30.14 GBP" */
  function priceFrom(el, attr) {
    if (!el) return null;
    var m = (el.getAttribute(attr) || "").match(/£\s*([0-9.]+)/);
    return m ? parseFloat(m[1]) : null;
  }

  function subRadio() {
    return document.querySelector(
      'input[data-radio-type="selling_plan"], ' +
      '.plan_card input[type="radio"]:not([data-radio-type="one_time_purchase"])');
  }

  /* 1 ── announcement bar: second slide becomes free-shipping message */
  retry(function () {
    var bar = document.querySelector("announcement-bar-component");
    if (!bar) return false;
    var nodes = [];
    bar.querySelectorAll("*").forEach(function (el) {
      if (!el.children.length && /SUBSCRIBE AND SAVE/i.test(el.textContent)) nodes.push(el);
    });
    if (!nodes.length) return false;
    if (nodes.length > 1) {
      nodes[1].textContent = "FREE UK SHIPPING, ALWAYS";
    } else {
      var msgs = ["SUBSCRIBE AND SAVE 33%", "FREE UK SHIPPING, ALWAYS"], i = 0;
      setInterval(function () { i = (i + 1) % 2; nodes[0].textContent = msgs[i]; }, 5000);
    }
    return true;
  }, 6, 1500);

  /* 2 ── homepage hero microline under the CTA */
  retry(function () {
    var hero = document.querySelector(".vp-hero6");
    if (!hero) return true; /* not the homepage - done */
    if (document.querySelector(".vp-cro-microline--hero")) return true;
    var btn = hero.querySelector("a.v5-btn, a.button, a[href*='/products']");
    if (!btn) return false;
    var m = document.createElement("span");
    m.className = "vp-cro-microline vp-cro-microline--hero";
    m.setAttribute("data-vp-annotated", "1");
    m.textContent = "From 96p a day · Free UK shipping · 30-day supply";
    btn.parentNode.insertBefore(m, btn.nextSibling);
    return true;
  }, 6, 1500);

  if (!/\/products\//.test(location.pathname)) return;

  /* 3 ── per-option prices on the plan cards.
     Both numbers are READ from the rendered radios - never computed from an
     assumed discount. See the header note for why. */
  retry(function () {
    var ot = document.querySelector('input[data-radio-type="one_time_purchase"]');
    if (!ot) return false;
    var full = priceFrom(ot, "data-variant-price") || priceFrom(ot, "aria-label");
    if (!full) return true;
    function chip(host, txt) {
      if (!host || host.querySelector(".vp-cro-optprice")) return;
      var s = document.createElement("span");
      s.className = "vp-cro-optprice";
      s.setAttribute("data-vp-annotated", "1");
      s.textContent = txt;
      host.appendChild(s);
    }
    chip(ot.closest("label") || ot.parentElement, "£" + full.toFixed(2));
    var si = subRadio();
    var sub = priceFrom(si, "data-variant-price") || priceFrom(si, "aria-label");
    if (si && sub) chip(si.closest("label") || si.parentElement, "£" + sub.toFixed(2));
    return true;
  }, 8, 1500);

  /* 4 ── microline under the PDP price */
  retry(function () {
    var priceEl = document.querySelector(".price__regular");
    if (!priceEl) return false;
    if (document.querySelector(".vp-cro-microline--pdp")) return true;
    var m = document.createElement("div");
    m.className = "vp-cro-microline vp-cro-microline--pdp";
    m.setAttribute("data-vp-annotated", "1");
    /* "Dispatched today" leads, added 2026-09-14 (owner confirmed Ecomflow
       always dispatches same day). It previously appeared ONLY in the cart -
       i.e. after the decision was already made. Same-day dispatch is a real
       differentiator against supplement brands shipping from abroad, so it
       belongs next to the price where the decision happens. */
    m.textContent = /quarterly-bundle-90/.test(location.pathname)
      ? "Order today, dispatched today · Free UK shipping · 90 lollipops = 3 months"
      : "Order today, dispatched today · Free UK shipping · 30 lollipops = 30 days";
    priceEl.parentNode.insertBefore(m, priceEl.nextSibling);
    return true;
  }, 6, 1500);

  /* 5 ── bundle PDP: mirror the ad's price anchor (verified 2026-08-21:
     3 x £35.99 = £107.97 vs £77.99 -> save £29.98, 87p/day) */
  if (/quarterly-bundle-90/.test(location.pathname)) {
    retry(function () {
      if (document.querySelector(".vp-cro-anchor")) return true;
      var host = document.querySelector(".plan_card") ||
                 document.querySelector(".price__regular");
      if (!host) return false;
      var d = document.createElement("div");
      d.className = "vp-cro-anchor";
      d.setAttribute("data-vp-annotated", "1");
      d.innerHTML = "3 single pouches: <s>£107.97</s> — you pay " +
        "<strong>£77.99</strong> (save £29.98). " +
        "That’s <strong>87p a day</strong> for your skin.";
      host.parentNode.insertBefore(d, host);
      return true;
    }, 8, 1500);
  }

  /* 6 ── sticky add-to-cart bar, mobile only, never over the consent sheet */
  if (MOBILE) {
    retry(function () {
      var form = document.querySelector("form.shopify-product-form, form[action*='/cart/add']");
      var atc = form && form.querySelector("button[name='add'], .add-to-cart-button");
      if (!form || !atc) return false;
      if (document.querySelector(".vp-cro-sticky")) return true;
      var img = document.querySelector("[id*='__main'] img");
      var priceTxt = (document.querySelector(".price__regular") || { textContent: "" })
        .textContent.trim();
      var bar = document.createElement("div");
      bar.className = "vp-cro-sticky";
      bar.innerHTML = (img ? '<img src="' + img.src + '" alt="">' : "") +
        '<span class="vp-cro-sticky-price" data-vp-annotated="1">' + priceTxt + "</span>" +
        '<button type="button" class="vp-cro-sticky-btn">Add to cart</button>';
      document.body.appendChild(bar);
      bar.querySelector(".vp-cro-sticky-btn").addEventListener("click", function () {
        atc.click();
      });
      var io = new IntersectionObserver(function (en) {
        var formVisible = en[0].isIntersecting;
        var consent = document.getElementById("shopify-pc__banner");
        var consentOpen = consent && consent.getClientRects().length > 0 && getComputedStyle(consent).display !== "none";
        bar.classList.toggle("on", !formVisible && !consentOpen);
      });
      io.observe(form);
      return true;
    }, 8, 1500);
  }

  /* 7 ── preselect "Subscribe and save" (added 2026-09-14).
     WHY: the Subscriptions app ships with One-time purchase CHECKED, so every
     ad click landed pre-set to the £44.99 one-off and had to actively switch
     to subscribe. 45% still chose subscription anyway, which is the signal
     that the default - not the demand - was the constraint.

     Safe by construction: it clicks a radio the customer could click
     themselves, once, only if the subscription option exists AND one-time is
     still the checked state. It never touches the form, the price or the cart,
     so its worst failure mode is doing nothing. Fires once, so a customer who
     switches back to one-time is never overridden.

     The recurring terms stay fully visible next to the selected option
     ("Auto-renews, skip or cancel anytime" plus the price) - this changes the
     default, not the disclosure. Revert by deleting this block. */
  var SUB_DEFAULT = true;
  if (SUB_DEFAULT) {
    retry(function () {
      var si = subRadio();
      if (!si) return false;                       /* not rendered yet */
      if (si.checked) return true;                 /* already on subscription */
      var ot = document.querySelector('input[data-radio-type="one_time_purchase"]');
      if (ot && !ot.checked) return true;          /* customer already chose - leave alone */
      /* A bare .click() fires an event with isTrusted:false. If the
         Subscriptions app only populates its hidden selling_plan field on a
         genuine interaction, the radio would LOOK selected while the cart
         still added a one-time purchase - the customer sees "Subscribe and
         save" and gets charged GBP44.99. Set state AND fire the events a real
         click would, so whichever the app listens for, it hears it. */
      si.checked = true;
      ['input', 'change', 'click'].forEach(function (type) {
        try { si.dispatchEvent(new Event(type, {bubbles: true})); } catch (e) {}
      });
      si.click();
      return true;
    }, 10, 800);
  }
})();
